<template>
  <div class="Ftim-box" v-if="infolist">
    <div class="Ftim-bt">
      <span>至德-</span>个人中心
      <i></i>
    </div>

    <div class="Current-box">
      <div class="Currbj-left"></div>

      <all-left></all-left>

      <div class="Current-right">
        <!-- 列表 -->
        <div class="" v-if="isshow==0">
          <div class="Current-topic">
            <div class="Current-name">我的纪念堂</div>
            <div class="Current-unread" @click="Gorele()">创建</div>
          </div>
          <div class="Current-cent">

            <div class="Current-list" v-for="(item, index) in infolist" :key="index">
              <div class="Current-pic">
                <img :src="item.cover">
              </div>
              <div class="Current-info">
                <div class="Current-fist">
                  <div class="Current-fistleft">
                    <div class="Current-leib" v-if="item.pc_type == 0">祖堂</div>
                    <div class="Current-leib" v-if="item.pc_type == 1">祠堂</div>
                    <div class="Current-leib" v-if="item.pc_type == 2">纪念堂</div>
                    <div class="Current-title">{{item.name}}</div>
                  </div>
                  <div class="Current-star" v-if="item.is_draft == 1">状态：草稿</div>
                  <div class="Current-star" v-if="item.is_draft == 0">状态：已发布</div>
                </div>
                
                <div class="Current-time">
                  <span>创建日期：{{item.created_at}}</span>
                  <span>到期日期：{{item.finish_at}}</span>
                </div>
                <div class="Current-bot">
                  <div class="Current-count">拜祭次数：{{item.pay_count}}</div>
                  <div class="">
                    <span class="Current-xf" v-if="item.is_draft == 0 && item.is_expiration == 1" @click="Renew(item.id,index)">续费</span>
                    <span class="Current-gl" v-if="item.is_draft == 0" @click="Lieguan(item,index)">管理</span>
                    <span class="Current-fab" v-if="item.is_draft == 1" @click="release(item)">发布</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="Ftim-more" @click="More" v-if="isgoto">加载更多</div>
          </div>
        </div>

        <!-- 发布 -->
        <div class="" v-if="isshow==1">
          <div class="Current-topic">
            <div class="Current-name">创建纪念堂</div>
            <div class="Ftim-fanhui" @click="Close()"></div>
          </div>
          <div class="Current-cent">
            <div class="reinfo-list">
              <i>*</i>
              <span>纪念堂名称</span>
              <el-input class="reinfo-inp" type="text" v-model="listcent.name" placeholder="请输入纪念堂名称"></el-input>
            </div>
            <div class="reinfo-list">
              <i>*</i>
              <span>类别</span>
              <el-select placeholder="请选择" v-model="listcent.pc_type">
                  <el-option
                  v-for="item in Degree"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id">
                  </el-option>
              </el-select>
            </div>

            <div class="reinfo-uppic">
              <div class="reinfo-uptop">
                <i>*</i>
                <span>人物遗像</span>
                <b>支持png、jpg格式</b>
              </div>
              
              <div class="picture-box">
                <div class="picture-up" v-if="!listcent.cover">
                  <el-upload
                    action=""
                    list-type="picture-card"
                    :before-upload="handleBeforeUpload"
                    :on-success="successHandle"
                    accept=".jpg, .jpeg, .png">
                    <i class="el-icon-plus"></i>
                  </el-upload>
                </div>

                <div class="picture-ever" v-if="listcent.cover">
                  <div class="picture-list">
                    <img :src="listcent.cover">
                    <span @click="delpic()"></span>
                  </div>
                </div>
                
              </div>
            </div>

            <div class="reinfo-styl">
              <i>*</i>
              <span>纪念堂外观</span>
              <div class="memorside">
                <div class="memorlist" v-for="(item,index) in waicover" :key="index" @click="waitab(item.id)">
                  <img :src="$uploadUrl+item.cover">
                  <span v-if="waiave == item.id"></span>
                </div>
              </div>
              <div class="Ftim-more" @click="Waimore" v-if="waiisgoto">加载更多</div>
            </div>

            <div class="reinfo-styl">
              <i>*</i>
              <span>纪念堂内观</span>
              <div class="memorside">
                <div class="memorlist" v-for="(item,index) in neicover" :key="index" @click="neitab(item.id)">
                  <img :src="$uploadUrl+item.cover">
                  <span v-if="neiave == item.id"></span>
                </div>
              </div>
              <div class="Ftim-more" @click="Neimore" v-if="neiisgoto">加载更多</div>
            </div>
            
            <div class="Ftim-text">* 纪念堂创建完成后可编辑添加简介、生平、后裔</div>

            <div class="reinfo-but">
              <div class="reinfo-close" @click="Submit(1)" v-if="this.isreorbj==1">保存草稿</div>
              <div class="reinfo-ok" @click="Submit(2)">支付并发布</div>
            </div>
          </div>
        </div>

        <!-- 添加编辑采购弹框 -->
        <div class="examine-mark" v-if="paytck" @click="closepay"></div>
        <div class="operate-tck" v-if="paytck">
          <div class="Current-sobox">
            <img :src="paypic">
          </div>
        </div>

        <!-- 管理 -->
        <div class="" v-if="isshow==2">
          <div class="Current-topic">
            <div class="Current-name">{{jnttitle}}</div>
            <div class="Current-want">
              <span :class="releid == item.id?'Current-reletab on':'Current-reletab'" v-for="(item,index) in strinfo" :key="index" @click="releqie(item.id,index)">{{item.title}}</span>
              <div class="Ftim-fanhui" @click="Close()"></div>
            </div>
            
          </div>
          <div class="Current-cent">
            <!-- 编辑纪念堂 -->
            <div class="" v-if="releid == 3">
              <div class="Current-cent">
                <div class="reinfo-list">
                  <i>*</i>
                  <span>纪念堂名称</span>
                  <el-input class="reinfo-inp" type="text" v-model="listcent.name" placeholder="请输入纪念堂名称"></el-input>
                </div>
                <div class="reinfo-list">
                  <i>*</i>
                  <span>类别</span>
                  <el-select placeholder="请选择" v-model="listcent.pc_type">
                      <el-option
                      v-for="item in Degree"
                      :key="item.id"
                      :label="item.title"
                      :value="item.id">
                      </el-option>
                  </el-select>
                </div>

                <div class="reinfo-uppic">
                  <div class="reinfo-uptop">
                    <i>*</i>
                    <span>人物遗像</span>
                    <b>支持png、jpg格式</b>
                  </div>
                  
                  <div class="picture-box">
                    <div class="picture-up" v-if="!listcent.cover">
                      <el-upload
                        action=""
                        list-type="picture-card"
                        :before-upload="handleBeforeUpload"
                        :on-success="successHandle"
                        accept=".jpg, .jpeg, .png">
                        <i class="el-icon-plus"></i>
                      </el-upload>
                    </div>

                    <div class="picture-ever" v-if="listcent.cover">
                      <div class="picture-list">
                        <img :src="listcent.cover">
                        <span @click="delpic()"></span>
                      </div>
                    </div>
                    
                  </div>
                </div>

                <div class="reinfo-styl">
                  <i>*</i>
                  <span>纪念堂外观</span>
                  <div class="memorside">
                    <div class="memorlist" v-for="(item,index) in waicover" :key="index" @click="waitab(item.id)">
                      <img :src="$uploadUrl+item.cover">
                      <span v-if="waiave == item.id"></span>
                    </div>
                  </div>
                  <div class="Ftim-more" @click="Waimore" v-if="waiisgoto">加载更多</div>
                </div>

                <div class="reinfo-styl">
                  <i>*</i>
                  <span>纪念堂内观</span>
                  <div class="memorside">
                    <div class="memorlist" v-for="(item,index) in neicover" :key="index" @click="neitab(item.id)">
                      <img :src="$uploadUrl+item.cover">
                      <span v-if="neiave == item.id"></span>
                    </div>
                  </div>
                  <div class="Ftim-more" @click="Neimore" v-if="neiisgoto">加载更多</div>
                </div>

                <div class="reinfo-but">
                  <div class="reinfo-save" @click="Submit(2)">保存修改</div>
                </div>
              </div>
            </div>

            <!-- 简介 -->
            <div class="" v-if="releid == 0">
              <div class="Current-reletext">
                <el-input 
                  v-model="releintro"
                  class="Agree-info"
                  type="textarea"
                  :rows="18"
                  placeholder="请输入介绍…">
                </el-input>
              </div>
              <div class="Current-introok" @click="reletrosub()">保存</div>
            </div>

            <!-- 后裔 -->
            <div class="" v-if="releid == 1">
              <div class="Current-reletext">
                <el-input 
                  v-model="relehouyi"
                  class="Agree-info"
                  type="textarea"
                  :rows="18"
                  placeholder="请输入后裔…">
                </el-input>
              </div>
              <div class="Current-introok" @click="reledantssub()">保存</div>
            </div>
            
            <!-- 生平 -->
            <div class="" v-if="releid == 2">
              <div class="Current-list" v-for="(item, index) in life_tracks" :key="index">
                <div class="Current-lifepic">
                  <img :src="item.picture[0]">
                </div>
                <div class="Current-info">
                  <div class="Current-lifetitle">{{item.title}}</div>
                  <div class="Current-bot">
                    <div class="Current-time">{{item.updated_at}}</div>
                    <div class="">
                      <span class="Current-bianji" @click="Publish(item,2)">编辑</span>
                      <span class="Current-shanchu" @click="Liedel(item.id,index)">删除</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="Current-introok" @click="Publish('',1)">发布生平</div>
            </div>
            

          </div>
        </div>

        <!-- 发布生平 -->
        <div class="" v-if="isshow == 3">
          <div class="Current-cent">
            <div class="">
               <div class="Current-topic">
                <div class="Current-name">发布生平</div>
                <div class="Current-want">
                  <span :class="releid == item.id?'Current-reletab on':'Current-reletab'" v-for="(item,index) in strinfo" :key="index" @click="releqie(item.id)">{{item.title}}</span>
                  <div class="Ftim-fanhui" @click="retshow()"></div>
                </div>
                
              </div>
              <div class="Current-cent">
                <div class="reinfo-list">
                  <i>*</i>
                  <span>生平标题</span>
                  <el-input class="reinfo-inp" type="text" v-model="tracklist.title" placeholder="请输入生平标题"></el-input>
                </div>

                <div class="reinfo-life">
                  <div class="reinfo-uptop">
                    <i>*</i>
                    <span>缩略图</span>
                    <b>最多上传9张图片，第一张为缩略图</b>
                  </div>
                  
                  <div class="picture-box">
                    <div class="picture-up" v-if="ruleForm.length<9">
                      <el-upload
                        action=""
                        list-type="picture-card"
                        :before-upload="handlife"
                        :on-success="successlife">
                        <i class="el-icon-plus"></i>
                      </el-upload>
                    </div>

                    <div class="picture-ever">
                      <div class="picture-life" v-for="(item,index) in ruleForm" :key="index">
                        <img :src="item">
                        <span @click="dellife(index)"></span>
                      </div>
                    </div>
                    
                  </div>
                </div>
        
                <div class="reinfo-jianjie">
                  <i>*</i>
                  <span>简介</span>
                  <el-input class="reinfo-tare" type="textarea" :rows="10" placeholder="请输入内容，限制500字符以内…" maxlength='500' v-model="tracklist.content"></el-input>
                </div>
                
                <div class="reinfo-but">
                  <div class="reinfo-ok" @click="Preserve()" v-if="fbspin == 1">保存</div>
                  <div class="reinfo-ok" @click="Preserve()" v-if="fbspin == 2">发布</div>
                </div>
              </div>
            </div>
            
            
          </div>
        </div>
        
        
      </div>

      <div class="Currbj-right"></div>
    </div>
   
  </div>
</template>
<script>
import AllLeft from '../../components/Personleft.vue';//个人中心公用左侧
export default {
  components:{
    AllLeft
  },
  data() {
    return {
      token: localStorage.pctoken,  //获取token
      infolist:[],
      isshow: 0,       //显示列表发布编辑
      waicover:[],     //外堂封面
      neicover:[],     //内堂封面
      waipage: 1,        //外堂当前页码
      waiisgoto: false,   //外堂是否显示加载更多
      waiave: '',         //外堂选择
      neipage: 1,        //内堂当前页码
      neiisgoto: false,   //内堂是否显示加载更多
      neiave:'',          //内堂选择
      page: 1,
      isgoto: false,
      listcent:{       //发布编辑参数
        name:'',
        pc_type:'',
        cover:'',
        inside_style_id:'',
        outside_style_id:'',
        is_draft:''
      },
      Degree:[
        {
          title:'祖堂',
          id: 0
        },
        {
          title:'祠堂',
          id: 1
        },
        {
          title:'纪念堂',
          id: 2
        },
      ],        //纪念堂分类
      strinfo:[
        {
          title:'纪念堂',
          id: 3
        },
        {
          title:'简介',
          id: 0
        },
        {
          title:'后裔',
          id: 1
        },
        {
          title:'生平',
          id: 2
        },
      ],        //纪念堂分类
      isreorbj: '',
      releid: 3,    //管理切换
      jntid: '',    //纪念堂id
      jnttitle:'',  //纪念堂名称
      releintro: '', //简介
      relehouyi: '', //后裔
      life_tracks:[], //生平列表
      tracklist:{     //添加编辑生平数据
        title:'',
        picture:[],
        content:'',
        memorial_id:''
      },
      ruleForm:[],
      fbspin: '', //发布生平是编辑还是创建 1是编辑 2是创建
      paytck: false,      //支付二维码弹框
      paypic:'',          //支付二维码
      glind:'',     //管理列表下标用于修改纪念堂
    };
  },
  created(){
    this.getData();
    this.getwaiMomor(); //获取外堂
    this.getneiMomor(); //获取内堂
  },
  mounted() {
  },
  methods: {

    //获取详情数据
    getData(){
      this.$layer.loading();
      this.$http.get('memorial?page='+this.page,{
        headers: {
          'Authorization': 'Bearer ' + this.token
        }
      }).then((res)=>{
        this.$layer.closeAll('loading');
        if(res.data.code == 200){
          this.infolist = this.infolist.concat(res.data.data.data);
          if(res.data.data.next_page_url != null){
            this.isgoto = true;
            this.page+=1
          }else{
            this.isgoto = false;
          }
        }else{
          this.$layer.msg(res.data.message);
        }
      })
    },

    //获取纪念堂外堂
    getwaiMomor(){
      this.$layer.loading();
      this.$http.get('memorial/side_style/1?page='+this.waipage,{
        headers: {
          'Authorization': 'Bearer ' + this.token
        }
      }).then((res)=>{
        if(res.data.code == 200){
          this.$layer.closeAll('loading');
          this.waicover = this.waicover.concat(res.data.data.data);
          if(res.data.data.next_page_url != null){
            this.waiisgoto = true;
            this.waipage+=1
          }else{
            this.waiisgoto = false;
          }
        }else{
          this.$layer.msg(res.data.message);
        }
      })
    },

    //获取纪念堂内堂
    getneiMomor(){
      this.$layer.loading();
      this.$http.get('memorial/side_style/0?page='+this.neipage,{
        headers: {
          'Authorization': 'Bearer ' + this.token
        }
      }).then((res)=>{
        this.$layer.closeAll('loading');
        if(res.data.code == 200){
          this.neicover = this.neicover.concat(res.data.data.data);
          if(res.data.data.next_page_url != null){
            this.neiisgoto = true;
            this.neipage+=1
          }else{
            this.neiisgoto = false;
          }
        }else{
          this.$layer.msg(res.data.message);
        }
      })
    },

    //点击列表发布
    release(msg){
      this.listcent = {
        id: msg.id,
        name: msg.name,
        pc_type: parseInt(msg.pc_type),
        cover: msg.cover,
        inside_style_id: String(msg.inside_style_id),
        outside_style_id: msg.outside_style_id,
      }
      this.neiave = String(msg.inside_style_id);
      this.waiave = msg.outside_style_id;
      this.isshow = 1;
      this.isreorbj = 2;
    },
    //列表加载更多
    More(){
      this.getData();
    },
    //外堂加载更多
    Waimore(){
      this.getwaiMomor();
    },
    //内堂加载更多
    Neimore(){
      this.getneiMomor();
    },

    //外堂点击选择
    waitab(id){
      this.waiave = id;
    },
    //内堂点击选择
    neitab(id){
      this.neiave = id;
    },

    //点击创建
    Gorele(){
      this.isshow = 1;
      this.isreorbj = 1;
    },

    //上传图片
    handleBeforeUpload(file) {
      const formData = new FormData();
      formData.append('img', file);
      this.uploadObject(formData);
      return false;
    },
    uploadObject(formData) {
      this.$layer.loading();
      this.$http.post('upload',formData,{
        headers: {
            'Authorization': 'Bearer ' + this.token}
      }).then(this.successHandle).catch(this.handleError);
    },
    successHandle(response) {
      this.$layer.closeAll('loading');
      this.listcent.cover = response.data.data.path;
    },

    //删除图片
    delpic(){
      this.listcent.cover = '';
    },

    //取消发布和编辑
    Close(){
      this.isshow = 0;
      this.listcent = {       //发布编辑参数
        name:'',
        pc_type:'',
        cover:'',
        inside_style_id:'',
        outside_style_id:''
      };
      this.waipage=1;
      this.waiisgoto= false;
      this.waiave='';
      this.neipage=1;
      this.neiisgoto=false;
      this.neiave='';
      this.releid = 3;
    },

    destroyed() {//销毁 
      clearInterval(this.times);   
      this.timer = null;
    },

    //创建成功后调取
    cjsuree(){
      let that = this;
      setTimeout(() => {
        that.paytck = false;
        that.isshow = 0;
        that.listcent = {       //发布编辑参数
          name:'',
          pc_type: -1,
          cover:'',
          inside_style_id:'',
          outside_style_id:''
        };
        that.waipage=1;
        that.waiisgoto= false;
        that.waiave='';
        that.neipage=1;
        that.neiisgoto=false;
        that.neiave='';
        that.infolist = [];
        that.getData();
        window.scrollTo({
          top: 300,
          behavior: "smooth" // 平滑滚动
        });
      }, 800);
    },
    
    //保存草稿和发布
    Submit(num){
      let that = this;
      that.listcent.inside_style_id = that.neiave;
      that.listcent.outside_style_id = that.waiave;

      if(!that.listcent.name){
        that.$layer.msg('请填写纪念堂名称');
        return
      }
      if(that.listcent.pc_type == -1){
        that.$layer.msg('请选择类别');
        return
      }
      if(!that.listcent.cover){
        that.$layer.msg('请上传人物遗像');
        return
      }
      if(!that.listcent.outside_style_id){
        that.$layer.msg('请选择纪念堂外观');
        return
      }
      if(!that.listcent.inside_style_id){
        that.$layer.msg('请选择纪念堂内堂');
        return
      }

      if(that.isreorbj == 1){
        that.listcent.is_draft = 1;
        that.$layer.loading();
        that.$http.post('memorial',that.listcent,{
          headers: {
            'Authorization': 'Bearer ' + that.token
          }
        }).then((res)=>{
          that.$layer.closeAll('loading');
          if(res.data.code == 200){
            if(num == 1){
              that.$layer.msg('保存草稿成功');
              that.cjsuree();
            }else if(num == 2){
              that.$http.post('create/qrcode',{
                mid: res.data.data.id
              },{
                headers: {
                  'Authorization': 'Bearer ' + that.token
                }
              }).then((msg)=>{
                that.$layer.closeAll('loading');
                if(msg.data.code == 200){
                  that.paytck = true;
                  that.paypic = msg.data.data;
                  that.times = setInterval(()=>{
                    that.$http.post('check/pay-status',{
                      mid: res.data.data.id
                    },{
                      headers: {
                        'Authorization': 'Bearer ' + that.token
                      }
                    }).then((item)=>{
                      that.$layer.closeAll('loading');
                      if(item.data.code == 200){
                        if(item.data.data == 0){ //待支付

                        }else if(item.data.data == 1){ //支付成功
                          that.destroyed();
                          that.$layer.msg('发布成功');
                          that.cjsuree();
                        }else if(item.data.data == 2){ //支付失败
                          that.destroyed();
                          that.$layer.msg('支付失败，已保存草稿');
                          that.cjsuree();
                        }
                      }else{
                        that.$layer.msg(item.data.message);
                      }
                    })
                  },1000)
                }else{
                  that.$layer.msg(msg.data.message);
                }
              })
            }
          }else{
            that.$layer.msg(res.data.message);
          }
        })
      }else if(that.isreorbj == 2){
        that.listcent.is_draft = 1;
        that.$layer.loading();
        that.$http.put('memorial',that.listcent,{
          headers: {
            'Authorization': 'Bearer ' + that.token
          }
        }).then((res)=>{
          that.$layer.closeAll('loading');
          if(res.data.code == 200){

            that.$http.post('create/qrcode',{
              mid: that.listcent.id
            },{
              headers: {
                'Authorization': 'Bearer ' + that.token
              }
            }).then((msg)=>{
              that.$layer.closeAll('loading');
              if(msg.data.code == 200){
                that.paytck = true;
                that.paypic = msg.data.data;
                that.times = setInterval(()=>{
                  that.$http.post('check/pay-status',{
                    mid: that.listcent.id
                  },{
                    headers: {
                      'Authorization': 'Bearer ' + that.token
                    }
                  }).then((item)=>{
                    that.$layer.closeAll('loading');
                    if(item.data.code == 200){
                      if(item.data.data == 0){ //待支付

                      }else if(item.data.data == 1){ //支付成功
                        that.destroyed();
                        that.$layer.msg('发布成功');
                        that.cjsuree();
                      }else if(item.data.data == 2){ //支付失败
                        that.destroyed();
                        that.$layer.msg('支付失败，已保存草稿');
                        that.cjsuree();
                      }
                    }else{
                      that.$layer.msg(item.data.message);
                    }
                  })
                },1000)
              }else{
                that.$layer.msg(res.data.message);
              }
            })
          }else{
            that.$layer.msg(res.data.message);
          }
        })
      }else if(that.isreorbj == 3){
        that.$layer.loading();
        delete that.listcent.is_draft;
        that.$http.put('memorial',that.listcent,{
          headers: {
            'Authorization': 'Bearer ' + that.token
          }
        }).then((res)=>{
          that.$layer.closeAll('loading');
          if(res.data.code == 200){
            that.$layer.msg('修改成功');
            that.infolist[that.glind].name = that.listcent.name;
            that.infolist[that.glind].cover = that.listcent.cover;
          }else{
            that.$layer.msg(res.data.message);
          }
        })
      }
    },

    //关闭支付二维码
    closepay(){
      this.paytck = false;
      this.isshow = 0;
      this.listcent = {       //发布编辑参数
        name:'',
        pc_type:'',
        cover:'',
        inside_style_id:'',
        outside_style_id:''
      };
      this.waipage=1;
      this.waiisgoto= false;
      this.waiave='';
      this.neipage=1;
      this.neiisgoto=false;
      this.neiave='';
      this.infolist = [];
      this.getData();
      this.destroyed();
      window.scrollTo({
        top: 200,
        behavior: "smooth" // 平滑滚动
      });
    },

    //续费
    Renew(id,index){
      let that = this;
      that.$http.post('create/qrcode',{
        mid: id
      },{
        headers: {
          'Authorization': 'Bearer ' + that.token
        }
      }).then((msg)=>{
        that.$layer.closeAll('loading');
        if(msg.data.code == 200){
          that.paytck = true;
          that.paypic = msg.data.data;
          that.times = setInterval(()=>{
            that.$http.post('check/pay-status',{
              mid: id
            },{
              headers: {
                'Authorization': 'Bearer ' + that.token
              }
            }).then((item)=>{
              that.$layer.closeAll('loading');
              if(item.data.code == 200){
                if(item.data.data == 0){ //待支付

                }else if(item.data.data == 1){ //支付成功
                  that.destroyed();
                  that.$layer.msg('续费成功');
                  this.getData();
                  this.paytck = false;
                }else if(item.data.data == 2){ //支付失败
                  that.destroyed();
                  that.$layer.msg('续费失败');
                  this.paytck = false;
                }
              }else{
                that.$layer.msg(item.data.message);
              }
            })
          },1000)
        }else{
          that.$layer.msg(msg.data.message);
        }
      })
    },


    // 点击列表管理
    Lieguan(msg,index){
      this.$layer.loading();
      this.glind = index;
      this.$http.get('memorial/'+msg.id,{
        headers: {
          'Authorization': 'Bearer ' + this.token
        }
      }).then((res)=>{
        this.$layer.closeAll('loading');
        if(res.data.code == 200){
          this.jntid = msg.id;
          this.jnttitle = msg.name;
          this.releintro = res.data.data.intro;
          this.relehouyi = res.data.data.houyi;
          this.life_tracks = res.data.data.life_tracks;
          this.listcent.id = msg.id,
          this.listcent.name = res.data.data.name;
          this.listcent.pc_type = parseInt(res.data.data.pc_type);
          this.listcent.cover = res.data.data.cover;
          this.listcent.inside_style_id = String(res.data.data.inside_style_id);
          this.listcent.outside_style_id = res.data.data.outside_style_id;
          this.neiave = String(res.data.data.inside_style_id);
          this.waiave = res.data.data.outside_style_id;
          this.isreorbj = 3;
          this.isshow = 2;
        }else{
          this.$layer.msg(res.data.message);
        }
      })
      
    },

    //管理切换
    releqie(id){
      this.releid = id;
      this.isshow = 2;
      this.tracklist = {
        title:'',
        picture:[],
        content:'',
        memorial_id:''
      },
      this.ruleForm = [];
      this.fbspin = '';
    },

    //简介修改
    reletrosub(){
      this.$layer.loading();
      let intro = {intro: this.releintro,id: this.jntid}
      this.$http.put('memorial',intro,{
        headers: {
          'Authorization': 'Bearer ' + this.token
        }
      }).then((res)=>{
        this.$layer.closeAll('loading');
        if(res.data.code == 200){
          this.$layer.msg('保存成功');
        }else{
          this.$layer.msg(res.data.message);
        }
      })
    },

    //后裔修改
    reledantssub(){
      this.$layer.loading();
      let intro = {houyi: this.relehouyi,id: this.jntid}
      this.$http.put('memorial',intro,{
        headers: {
          'Authorization': 'Bearer ' + this.token
        }
      }).then((res)=>{
        this.$layer.closeAll('loading');
        if(res.data.code == 200){
          this.$layer.msg('保存成功');
        }else{
          this.$layer.msg(res.data.message);
        }
      })
    },

    // 发布生平
    Publish(item){
      if(item){
        this.tracklist = {
          title: item.title,
          content: item.content,
          id: item.id,
        },
        this.ruleForm = item.picture;
        this.fbspin = 1;
      }else{
        this.fbspin = 2;
      }
      this.isshow = 3;
    },

    //从发布生平返回
    retshow(){
      this.isshow = 2;
      this.tracklist = {
        title:'',
        picture:[],
        content:'',
        memorial_id:''
      },
      this.ruleForm = [];
      this.fbspin = '';
    },

    //生平上传缩略图
    handlife(file) {
      const formData = new FormData();
      formData.append('img', file);
      this.uploadlife(formData);
      return false;
    },
    uploadlife(formData) {
      this.$layer.loading();
      this.$http.post('upload',formData,{
        headers: {
            'Authorization': 'Bearer ' + this.token}
      }).then(this.successlife).catch(this.handleError);
    },
    successlife(response) {
      this.$layer.closeAll('loading');
      this.ruleForm.push(response.data.data.path);
    },

    //生平缩略图删除图片
    dellife(index){
      this.ruleForm.splice(index,1)
    },

    //重新拉取纪念堂详情并清空发布生平数据
    Onceagain(){
      this.$layer.loading();
      this.$http.get('memorial/'+this.jntid,{
        headers: {
          'Authorization': 'Bearer ' + this.token
        }
      }).then((res)=>{
        this.$layer.closeAll('loading');
        if(res.data.code == 200){
          this.releintro = res.data.data.intro;
          this.relehouyi = res.data.data.houyi;
          this.life_tracks = res.data.data.life_tracks;
          this.listcent.name = res.data.data.name;
          this.listcent.pc_type = parseInt(res.data.data.pc_type);
          this.listcent.cover = res.data.data.cover;
          this.listcent.inside_style_id = String(res.data.data.inside_style_id);
          this.listcent.outside_style_id = res.data.data.outside_style_id;
          this.neiave = String(res.data.data.inside_style_id);
          this.waiave = res.data.data.outside_style_id;
          this.isreorbj = 3;
          this.tracklist = {
            title:'',
            picture:[],
            content:'',
            memorial_id:''
          },
          this.ruleForm = [];
          window.scrollTo({
            top: 300,
            behavior: "smooth" // 平滑滚动
          });
        }else{
            this.$layer.msg(res.data.message);
        }
      })
    },

    //发布生平
    Preserve(){
      this.tracklist.picture = this.ruleForm;
      if(!this.tracklist.title){
        this.$layer.msg('请填写生平标题');
        return
      }
      if(this.tracklist.picture.length<0){
        this.$layer.msg('请上传缩略图');
        return
      }
      if(!this.tracklist.content){
        this.$layer.msg('请填写内容');
        return
      }
      this.tracklist.memorial_id = this.jntid;

      this.$layer.loading();
      if(this.fbspin == 1){
        this.$http.put('memorial/life_track',this.tracklist,{
          headers: {
            'Authorization': 'Bearer ' + this.token
          }
        }).then((res)=>{
          this.$layer.closeAll('loading');
          if(res.data.code == 200){
            this.$layer.msg('修改成功');
            setTimeout(() => {
              //重新拉取纪念堂详情
              this.Onceagain();
            }, 800);
          }else{
            this.$layer.msg(res.data.message);
          }
        })
      }else if(this.fbspin == 2){
        this.$http.post('memorial/life_track',this.tracklist,{
          headers: {
            'Authorization': 'Bearer ' + this.token
          }
        }).then((res)=>{
          this.$layer.closeAll('loading');
          if(res.data.code == 200){
            this.$layer.msg('发布成功');
            setTimeout(() => {
              //重新拉取纪念堂详情
              this.Onceagain();
            }, 800);
          }else{
            this.$layer.msg(res.data.message);
          }
        })
      }
    },

    //删除生平
    Liedel(id,index){
      this.$layer.loading();
      this.$http.delete('memorial/life_track/'+id,{
        headers: {
          'Authorization': 'Bearer ' + this.token
        }
      }).then((res)=>{
        this.$layer.closeAll('loading');
        if(res.data.code == 200){
          this.$layer.msg('删除成功');
          this.life_tracks.splice(index,1);
        }else{
          this.$layer.msg(res.data.message);
        }
      })
    },


  },
};
</script>
<style scoped>
  .Ftim-box{
    background: url(../../../public/images/dysjbjt.png) top no-repeat;
    margin-bottom: 20px;
  }
  .Ftim-bt{
    width: 1200px;
    margin: 72px auto 0;
    font-weight: bold;
    font-size: 48px;
    color: #333;
    line-height: 48px;
  }
  .Ftim-bt span{
    color: #D71E1C;
  }
  .Ftim-bt i{
    display: block;
    width: 48px;
    height: 4px;
    background: #D71E1C;
    margin-top: 30px;
  }
  .Current-box{
    width: 1200px;
    margin: 80px auto 0;
    display: flex;
  }
  .Currbj-left{
    width: 30px;
    height: 790px;
    background: url(../../../public/images/grleft.png) bottom no-repeat;
  }
  .Currbj-right{
    width: 30px;
    height: 790px;
    background: url(../../../public/images/grright.png) bottom no-repeat;
  }
  .Current-right{
    flex: 1;
    background: #fff;
    border-left: 1px solid #d8d8d8;
    padding: 40px 0 0 40px;
    height: 700px;
    overflow: auto;
    border-radius: 0 20px 0 0;
  }
  .Current-cent{
    max-height: 640px;
    overflow: auto;
  }
  
  .Current-cent::-webkit-scrollbar {
    width: 2px;
    height: 4px;
    margin-top: 10px;
  }

  .Current-cent::-webkit-scrollbar-thumb {
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
    background: rgba(0,0,0,0.2);
  }

  .Current-cent::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
    border-radius: 0;
    background: rgba(0,0,0,0.1);
  }
  .Current-topic{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 10px;
    border-bottom: 1px solid #d8d8d8;
    margin-right: 40px;
  }
  .Current-name{
    font-weight: bold;
    font-size: 24px;
    color: #333333;
  }
  .Current-want{
    display: flex;
    align-items: center;
  }
  .Current-unread{
    width: 80px;
    height: 28px;
    background: linear-gradient( 139deg, #ED403C 0%, #D71E1C 100%);
    border-radius: 14px;
    font-weight: 400;
    font-size: 14px;
    color: #FFFFFF;
    line-height: 28px;
    text-align: center;
    cursor: pointer;
  }
  .Current-list{
    display: flex;
    width: 760px;
    border-bottom: 1px solid #D8D8D8;
    margin-top: 20px;
    padding: 20px;
  }
  .Current-pic{
    width: 84px;
    height: 84px;
    border-radius: 8px;
  }
  .Current-pic img{
    width: 84px;
    height: 84px;
    border-radius: 8px;
  }
  .Current-info{
    flex: 1;
    margin-left: 20px;
  }
  .Current-fist{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .Current-fistleft{
    display: flex;
    align-items: center;
  }
  .Current-leib{
    font-size: 12px;
    color: #FFFFFF;
    padding: 2px 10px;
    background: linear-gradient( 139deg, #ED403C 0%, #D71E1C 100%);
    border-radius: 9px;
  }
  .Current-title{
    font-size: 16px;
    color: #333333;
    overflow:hidden;   /* 溢出部分进行隐藏 */
    display: -webkit-box;  
    -webkit-box-orient: vertical;  /* 盒模型元素从顶部向底部垂直排列子元素 */
    -webkit-line-clamp: 1;  /* 显示两行 */
    text-overflow: ellipsis; 
    margin-left: 10px;
  }
  .Current-star{
    font-size: 16px;
    color: #999999;
  }
  .Current-time{
    font-size: 16px;
    color: #999999;
    margin-top: 10px;
  }
  .Current-time span{
    margin-right: 15px;
  }
  .Current-bot{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 5px;
  }
  .Current-count{
    font-size: 16px;
    color: #999999;
  }
  .Current-xf{
    background: linear-gradient( 137deg, #FFB73A 0%, #FE6809 100%), #F2F2F2;
    border-radius: 12px;
    line-height: 24px;
    text-align: center;
    padding: 4px 18px;
    font-weight: 400;
    font-size: 16px;
    color: #FFFFFF;
    cursor: pointer;
    margin-right: 16px;
  }
  .Current-gl{
    background: linear-gradient( 139deg, #ED403C 0%, #D71E1C 100%), #F2F2F2;
    border-radius: 12px;
    line-height: 24px;
    text-align: center;
    padding: 4px 18px;
    font-weight: 400;
    font-size: 16px;
    color: #FFFFFF;
    cursor: pointer;
  }
  .Current-fab{
    background: linear-gradient( 139deg, #ED403C 0%, #D71E1C 100%), #F2F2F2;
    border-radius: 12px;
    line-height: 24px;
    text-align: center;
    padding: 4px 18px;
    font-weight: 400;
    font-size: 16px;
    color: #FFFFFF;
    cursor: pointer;
  }
  .Ftim-more{
    width: 180px;
    height: 36px;
    background: #F2F2F2;
    border-radius: 18px;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    line-height: 36px;
    text-align: center;
    margin: 40px auto 0;
    cursor: pointer;
  }
  .reinfo-list{
    display: flex;
    border-bottom: 1px dotted #D8D8D8;
    align-items: center;
    margin-top: 20px;
    padding-bottom: 16px;
  }
  .reinfo-list i{
      width: 6px;
      color: #E2195C;
  }
  .reinfo-list span{
      width: 110px;
      font-size: 16px;
      color: #333;
      margin-left: 2px;
  }
  .reinfo-inp{
    width: 90%;
  }
  ::v-deep .reinfo-list .reinfo-inp .el-input__inner{
      width: 90%;
      font-size: 16px;
      font-family: ArialMT;
      color: #666666;
      border: none;
      padding: 0;
  }
  ::v-deep .reinfo-list .el-input--suffix .el-input__inner{
    border: none;
    background: #F2F2F2;
    border-radius: 16px;
  }
  
  .reinfo-uppic{
    border-bottom: 1px dotted #D8D8D8;
    margin-top: 20px;
    padding-bottom: 16px;
  }
  ::v-deep .reinfo-uppic .el-upload--picture-card{
    width: 72px;
    height: 90px !important;
    line-height: 100px !important;
  }
  .reinfo-uptop{
    display: flex;
    align-items: center;
  }
  .reinfo-uptop i{
    width: 6px;
    color: #E2195C;
  }
  .reinfo-uptop span{
    width: 110px;
    font-size: 16px;
    color: #333;
    margin-left: 2px;
  }
  .reinfo-uptop b{
    font-size: 16px;
    color: #D8D8D8;
    font-weight: 400;
  }
  .picture-box{
    display: flex;
    align-items: center;
    margin-top: 16px;
    margin-left: 120px;
  }
  .picture-up{
    margin-right: 20px;
  }
  .picture-ever{
    display: flex;
    align-items: center;
  }
  .picture-list{
    position: relative;
    margin-right: 20px;
  }
  .picture-list img{
    width: 72px;
    height: 90px;
    border-radius: 6px;
  }
  .picture-list span{
    display: block;
    position: absolute;
    top: -8px;
    right: -9px;
    width: 18px;
    height: 18px;
    background: url(../../../public/images/gb.png) no-repeat;
    background-size: 100% 100%;
    cursor: pointer;
  }
  .reinfo-but{
    display: flex;
    width: 440px;
    margin: 10px 0 0 120px;

  }
  .reinfo-close{
    width: 200px;
    height: 36px;
    background: #D8D8D8;
    border-radius: 18px;
    font-size: 18px;
    color: #333333;
    line-height: 36px;
    text-align: center;
    cursor: pointer;
  }
  .reinfo-save{
    width: 200px;
    height: 36px;
    background: #D8D8D8;
    border-radius: 18px;
    font-size: 18px;
    color: #333333;
    line-height: 36px;
    text-align: center;
    cursor: pointer;
    margin: 0 auto;
  }
  .reinfo-ok{
    width: 200px;
    height: 36px;
    background: linear-gradient( 139deg, #ED403C 0%, #D71E1C 100%), #D8D8D8;
    border-radius: 18px;
    font-size: 18px;
    color: #fff;
    line-height: 36px;
    margin-left: 20px;
    text-align: center;
    cursor: pointer;
    margin: 0 auto;
  }
  .bordnone{
    border-bottom: none;
  }
  .reinfo-styl{
    border-bottom: 1px dotted #D8D8D8;
    margin-top: 20px;
    padding-bottom: 16px;
  }
  .reinfo-styl i{
      width: 6px;
      color: #E2195C;
  }
  .reinfo-styl span{
      width: 110px;
      font-size: 16px;
      color: #333;
      margin-left: 2px;
  }
  .memorside{
    display: flex;
    align-items: center;
    flex-wrap: wrap;

  }
  .memorlist{
    position: relative;
    width: 190px;
    height: 190px;
    margin-right: 20px;
    margin-top: 16px;
    cursor: pointer;
  }
  .memorside img{
    display: block;
    width: 190px;
    height: 190px;
    border-radius: 12px;
  }
  
  .memorlist span{
    display: block;
    width: 190px;
    height: 190px;
    border-radius: 12px;
    position: absolute;
    top: 0;
    left: -2px;
    background: url(../../../public/images/tangxz.png) 50% 50% no-repeat rgba(255, 255, 255, 0.60);
    background-size: 40px 40px;
  }
  .Ftim-fanhui{
    width: 20px;
    height: 20px;
    margin-right: 16px;
    margin-left: 10px;
    background: url(../../../public/images/fanhui.png) right center no-repeat;
    background-size: 20px 20px;
    cursor: pointer;
  }
  .Current-reletab{
    display: inline-block;
    width: 64px;
    height: 28px;
    background: #F2F2F2;
    border-radius: 14px;
    margin-right: 16px;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    line-height: 28px;
    text-align: center;
    cursor: pointer;
  }
  .Current-reletab.on{
    background: linear-gradient( 139deg, #ED403C 0%, #D71E1C 100%), #F2F2F2;
    color: #fff;
  }
  .Current-reletext{
    width: 95%;
    border: 1px solid #D8D8D8;
    margin-top: 30px;
  }
  ::v-deep .Agree-info .el-textarea__inner{
    padding: 10px 15px;
    font-size: 16px;
    border: none;
    resize: none;
  }
  .Current-introok{
    width: 200px;
    height: 36px;
    background: linear-gradient( 139deg, #ED403C 0%, #D71E1C 100%), #D8D8D8;
    border-radius: 18px;
    font-size: 18px;
    color: #FFFFFF;
    line-height: 36px;
    text-align: center;
    margin: 40px auto 0;
    cursor: pointer;
  }
  .reinfo-jianjie{
    display: flex;
    border-bottom: 1px dotted #D8D8D8;
    margin-top: 20px;
    padding-bottom: 16px;
  }
  
  .reinfo-jianjie i{
      width: 6px;
      color: #E2195C;
  }
  .reinfo-jianjie span{
      width: 116px;
      display: block;
      font-size: 16px;
      color: #333;
      margin-left: 2px;
  }
  .reinfo-tare{
    width: 90%;
  }
  ::v-deep .reinfo-tare .el-textarea__inner{
    width: 80%;
    border: none;
    font-size: 16px;
    padding: 0;
    resize: none;
  }
  .reinfo-life{
    border-bottom: 1px dotted #D8D8D8;
    margin-top: 20px;
    padding-bottom: 16px;
  }
  ::v-deep .reinfo-life .el-upload--picture-card{
    width: 72px;
    height: 72px !important;
    line-height: 79px !important;
  }
  .picture-life{
    position: relative;
    margin-right: 20px;
  }
  .picture-life img{
    width: 72px;
    height: 72px;
    border-radius: 6px;
  }
  .picture-life span{
    display: block;
    position: absolute;
    top: -8px;
    right: -9px;
    width: 18px;
    height: 18px;
    background: url(../../../public/images/gb.png) no-repeat;
    background-size: 100% 100%;
    cursor: pointer;
  }
  .Current-bianji{
    font-weight: 400;
    font-size: 14px;
    color: #999999;
    padding-left: 20px;
    background: url(../../../public/images/bianjbjt.png) left no-repeat;
    background-size: 16px 17px;
    line-height: 26px;
    cursor: pointer;
  }
  .Current-shanchu{
    font-weight: 400;
    font-size: 14px;
    color: #999999;
    padding-left: 20px;
    background: url(../../../public/images/shanchubjt.png) left no-repeat;
    background-size: 16px 17px;
    line-height: 26px;
    cursor: pointer;
    margin-left: 20px;
  }
  .Current-lifepic{
    width: 165px;
    height: 120px;
    border-radius: 8px;
  }
  .Current-lifepic img{
    width: 165px;
    height: 120px;
    border-radius: 8px;
  }
  .Current-lifetitle{
    font-size: 16px;
    color: #333333;
    height: 84px;
  }
  .examine-mark{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    z-index: 3;
  }
  .operate-tck{
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    z-index: 10;
  }
  .Current-sobox{
    padding: 30px 40px;
    background: #FFFFFF;
    border-radius: 12px;
  }
  .Ftim-text{
    margin: 20px 0;
    color: #D71E1C;
  }
</style>